"use client"

import { ChevronLeft } from 'lucide-react'
import React from 'react'
import { useRouter, usePathname, useSearchParams } from 'next/navigation'
import { useRegionAwareHref } from '@/shared/hooks/use-region-aware-href'
import { HOMEOWNERS_ROUTES } from '@/shared/constants/pages-routes'
import { getReturnUrl } from '@/shared/lib/utils/navigation-helpers'

function BackButton() {
    const router = useRouter()
    const pathname = usePathname()
    const searchParams = useSearchParams()
    const homeownersHref = useRegionAwareHref(HOMEOWNERS_ROUTES.base)
    
    // Extract homeowner ID from pathname
    const homeownerIdMatch = pathname.match(/\/homeowners\/(\d+)/)
    const homeownerId = homeownerIdMatch ? homeownerIdMatch[1] : null
    
    const handleBack = () => {
        // Try to get return URL from sessionStorage or query param
        const returnUrl = getReturnUrl(homeownerId || undefined)
        
        if (returnUrl) {
            // Navigate to the stored return URL
            router.push(returnUrl)
        } else {
            // Fallback to homeowners base route
            router.push(homeownersHref)
        }
    }
    
    return (
        <button onClick={handleBack}>
            <ChevronLeft className='w-7 h-7' />
        </button>
    )
}

export default BackButton
